import { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";

export default function NewsletterForm({ source = "site", dark = false, buttonLabel = "SUBSCRIBE", testId = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Enter a valid email address.");
      return;
    }
    setError("");
    setStatus("loading");
    try {
      await api.subscribe(email, source);
      setStatus("success");
    } catch {
      setStatus("error");
      setError("Something glitched. Try again.");
    }
  };

  if (status === "success") {
    return (
      <div className={`flex items-center gap-3 font-mono text-xs tracking-[0.15em] ${dark ? "text-obsidian" : "text-gold-bright"}`} data-testid={`${testId}-success`}>
        <span className={`w-8 h-8 rounded-full flex items-center justify-center ${dark ? "bg-obsidian text-gold-bright" : "bg-gold/20 text-gold-bright"}`}>
          <Check size={15} />
        </span>
        YOU'RE IN. STAY LOCKED.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full" data-testid={`${testId}-form`} noValidate>
      <div className={`flex flex-col sm:flex-row gap-3 ${dark ? "" : ""}`}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="YOUR EMAIL"
          data-testid={`${testId}-email-input`}
          className={`flex-1 font-mono text-xs tracking-[0.15em] px-5 py-4 rounded-full outline-none transition-colors placeholder:text-current placeholder:opacity-50 ${
            dark
              ? "bg-obsidian text-cream border border-obsidian focus:border-gold-bright"
              : "bg-obsidian/60 text-cream border border-tan/30 focus:border-burnt"
          }`}
        />
        <button
          type="submit"
          disabled={status === "loading"}
          data-testid={`${testId}-submit`}
          className={`flex items-center justify-center gap-2 font-mono text-xs tracking-[0.2em] px-8 py-4 rounded-full transition-all duration-300 disabled:opacity-60 ${
            dark ? "bg-obsidian text-cream hover:bg-wood" : "bg-burnt hover:bg-burnt-hover text-cream hover:shadow-[0_0_30px_rgba(200,90,23,0.4)]"
          }`}
        >
          {status === "loading" ? "LOCKING IN..." : buttonLabel}
          <ArrowRight size={14} />
        </button>
      </div>
      {error && (
        <p className={`mt-3 font-mono text-[11px] tracking-[0.1em] ${dark ? "text-obsidian" : "text-burnt-hover"}`} data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
    </form>
  );
}
